<template>
	<div class="" @click="$sidebar.displaySidebar(false)">			
		<div class="row ">
            <div class="col-xl-8 mb-5 mb-xl-0">
                <div class="card shadow">
                    <div class="card-body">
						<div class="card-body-head">
 						<h4 class="mb-3 card-ttl">サイト情報</h4>
						<div class="cnt-wrap"><span class="cnt"> {{ totalSite }}件</span></div>
                     
						<div class="download-wrap">
							
							<button
								@click="csvExport"
								type="button" class="btn btn-download">
								CSVダウンロード
							</button>
							
							<a class="btn btn-primary" href="/site/create" v-show="permission_list['site-create'] ? true:false">サイトを追加する</a>
						</div>
						
					</div>

						<div class="loading"  v-show="loading">受信中...</div>
						<div class="el-table__body-wrapper table-responsive">
							<table class='table table-striped el-table__body' v-if="!loading">
								<thead>
									<tr class="el-table__row">
										<th scope="col">ID</th>
										<th scope="col">サイト名</th>
										<th scope="col">契約ドメイン</th>
										<th scope="col">タイムゾーン</th>
										<th scope="col">契約プラン</th>
										<th scope="col">契約日</th>
										<th scope="col">&nbsp;</th>
									</tr>
								</thead>
								<tbody>
									<tr  v-for="site in siteList.data" :key="site.id" class="el-table__row">
										<td class="el-table_1_column_1"> {{ site.id }} </td>
										<td class="el-table_1_column_4" max-width="200px" > 
											{{ site.site_name_jp }}
											</td>
										<td class="el-table_1_column_2" max-width="150px"> {{ site.site_domain }} </td>
										<td class="el-table_1_column_3" max-width="150px" > (UTC{{ site.utcoffset }}) {{ parseTimezone(site.timezone) }} </td>
										
										<td class="el-table_1_column_2" max-width="150px"> {{ site.plan_title }} </td>
										<td class="el-table_1_column_2" max-width="150px"> {{ site.plan_change_date ? site.plan_change_date : site.contract_date }} </td>
										<td class="el-table_1_column_5">
											<div class="btn-wrap form-group text-center">
											<a class="btn btn-primary no-bg-btn" :href="'/site/info/'+ site.id">編集</a>
											<!--
       										<a class="btn btn-primary" :href="'/users/'+ user.id + '/edit'" v-show="permission_list['user-edit'] ? true:false" >編集</a>
											-->
											</div>
										</td>
									</tr>
								</tbody>
							</table>
						</div>	
					</div>
                </div>
            </div>
			
			<div class="pagination-wrap">
			<pagination align="center" :data="siteList" :show-disabled="true" :limit=10 @pagination-change-page="getResults">
				<span slot="prev-nav">&lt;</span>
				<span slot="next-nav">&gt;</span>
			</pagination>
			</div>
			
		</div>
	</div>
</template>

<script>
import pagination from 'laravel-vue-pagination'

export default {
	components: { pagination},
	props: ['siteList'],
	data() {
		return {
			// Our data object that holds the Laravel paginator data
			siteId: null,
			site_name_jp: "",
			siteList: {},
			lastpage: null,
			totalSite:0,
			errors: {},
			loading: false
		}
	},

	mounted() {
		// Fetch initial results
		this.siteId = window.PushL.site_id;	
		this.siteList = JSON.parse(this.siteList);
		this.totalSite = this.siteList.total;
		//this.siteContract = JSON.parse(this.siteContract);
		this.lastpage = this.siteList.last_page
		console.log(this.siteList);
		//console.log(siteContract);
	},

	methods: {
		async getTimezone () {
			const url = '/json/timezones.json';
			const params = { };
			axios.get(url, params)
			.then(response => {
				this.allTimezones = response.data;
			});
		},
		parseTimezone(timezone) {
			console.log(timezone);
			if(timezone) {
				const t = timezone.split("--");
				return t[0];
			}
			return "";
		},

		csvExport() {
			let csvContent = "data:text/csv;charset=utf-8,";
			
			const len = this.siteList.data.length;
			console.log(len);
			if(len == 0) return;

			let arrData = [];
			for(let i=0; i<len; i++ ) {
				let site = this.siteList.data[i];
                let temp ={ 
					id:site.id, 
					'サイト名':site.site_name_jp,
					'ドメイン':site.site_domain,
					'タイムゾーン': this.parseTimezone(site.timezone),
					'プラン':site.plan_title,
					'契約日':site.plan_change_date ? site.plan_change_date : site.contract_date
				};
				arrData.push(temp);
			}

			csvContent += [
				Object.keys(arrData[0]).join(";"),
				...arrData.map(item => Object.values(item).join(";"))
			]
				.join("\n")
				.replace(/(^\[)|(\]$)/gm, "");

			const data = encodeURI(csvContent);
			const link = document.createElement("a");
			link.setAttribute("href", data);
			const fileName = 'Sitelist'
			link.setAttribute("download", fileName);
			link.click();
    	},
		
		getResults(page = 1) {
			if(this.lastpage != null && this.lastpage < page) return;
			axios.get('/sites?page=' + page)
				.then(response => {
					this.siteList = response.data;
					this.lastpage = response.data.last_page
				});
		},
	}

}
</script>

<style scoped>
.selected-option {
	display:block;
	min-width:200px;
}
.copybutton {
	background-color:transparent;
	border:0;
	outline:0;
	cursor:pointer;
	opacity:1;
	position:absolute;
	top: 10px;
	right:10px;
	z-index:9;
	border-radius:24px;
}
.button-tooltip-container {
    display: flex;
    align-items: center;
    margin-top: 16px;
    min-height: 30px;
}

#custom-tooltip {
    display: none;
    margin-left: 40px;
    padding: 5px 12px;
	background-color: rgba(94,118,228, .9);
    border-radius: 4px;
    color: #fff;
	position:absolute;
	right:10px;
	top: -40px;
}

textarea {
	width: 100%;
	height: 200px;
	resize: none;
	border:1px solid #CDD3D9;
}
.opt-val {
	display:block;
	margin-top: 10px;
}

.card {
	/*max-width: 1024px;*/
}

.card-body {
	padding: 3.6rem;
}


</style>